import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SubscriptionsService } from '../../services/subscriptions.service';
import { filter, retry, switchMap, take, tap } from 'rxjs/operators';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { GlobalMessageService, GlobalMessageType, RoutingService, WindowRef } from '@spartacus/core';
import { CheckoutStepService } from '@spartacus/checkout/base/components';
import { GenActiveCartService } from 'src/app/generac/features/cart/core/facade/active-cart.service';
import { Cart } from '@spartacus/cart/base/root';
import { GenBaseStoreService } from '../../services/base-store.service';
import { GenCustomerService } from '../../services/customer.service';

@Component({
  selector: 'gen-subscriptions',
  templateUrl: './subscriptions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenSubscriptionsComponent implements OnInit, OnDestroy {
  subscriptions$: any;
  cart$: Observable<Cart> = this.activeCartFacade.getActive();
  isReady = true;
  subscriptions = new Subscription();
  contactForPricingHref: string;
  tooltipMessage: string;
  phoneOrEmail: string;

  constructor(
    private subscriptionsService: SubscriptionsService,
    private userAccount: UserAccountFacade,
    private routing: RoutingService,
    private activeCartFacade: GenActiveCartService,
    protected checkoutStepService: CheckoutStepService,
    protected winRef: WindowRef,
    private cdr: ChangeDetectorRef,
    private globalMessageService: GlobalMessageService,
    private baseStoreService: GenBaseStoreService,
    private customerService: GenCustomerService,
  ) {
    this.getPhoneNumber();
  }

  ngOnInit(): void {
    this.loadSubscriptions();
    this.subscribeToUnitChange();
  }

  private loadSubscriptions(): void {
    this.subscriptions.add(
      this.userAccount.get().pipe(
        filter(user => !!user),
        take(1),
        tap(() => {
          this.isReady = false;
          this.cdr.detectChanges();
        }),
        switchMap(user => this.subscriptionsService.getSubscriptions(user?.uid).pipe(retry(2))),
        tap(subs => {
          if (subs?.products?.length) {
            this.isReady = true;
            this.subscriptions$ = subs;
            this.cdr.detectChanges();
          } else {
            this.routing.go('/');
            this.globalMessageService.add('Subscriptions are not available for the current company', GlobalMessageType.MSG_TYPE_WARNING);
          }
        })
      ).subscribe()
    );
  }

  private subscribeToUnitChange(): void {
    this.subscriptions.add(
      this.customerService.getB2bUnitChanged().pipe(
        filter((isB2bUnitChanged) => !!isB2bUnitChanged),
        tap(() => this.loadSubscriptions())
      ).subscribe()
    );
  }

  private getPhoneNumber() {
    this.subscriptions.add(
      combineLatest([
        this.baseStoreService.getTooltipMessage(),
        this.baseStoreService.getPhoneNumber(),
      ]).subscribe(([messsage, phoneOrEmail]) => {
        this.contactForPricingHref = phoneOrEmail?.contactInfo?.includes('@') ? `mailto: ${phoneOrEmail}` : `tel: ${phoneOrEmail}`;
        this.tooltipMessage = messsage?.message;
        this.phoneOrEmail = phoneOrEmail?.contactInfo;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
